<!-- <button (click)="loginGoogle()"></button> -->
<header>
    <h3>MISIÓN CONTROL UCN </h3>
  </header>
<main>
    <div id="wallSkew" class="wallSkew"></div>
    <div id="wallSkew2" class="wallSkew"></div>
    <!-- <img src="/resources/logo.png" alt="" class="logo"> -->
    <h1 class="titleP">MISIÓN CONTROL <br>
        MATRÍCULAS</h1>
        <button (click)="loginGoogle()" id="btnLogin">Iniciar sesión con Google</button>
    <h1 class="titleS">UNIVERSIDAD CENTRAL DE NICARAGUA</h1>

    <form id="formLogin" action="">
        <div class="body-form">
            <!-- <h3 class="title">INICIAR SESIÓN</h3> -->
            <!-- <button (click)="loginGoogle()" id="btnLogin">Iniciar sesión con Google</button> -->
            
        </div>
    </form>
</main>
